import __vue_component__ from './PresenceWrapper.vue.js';

//
var script = {
  name: 'Busy',
  components: {
    PresenceWrapper: __vue_component__
  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Avatar/Icons/Busy.vue_rollup-plugin-vue=script.js